// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lX-X5","toggle":"styles_toggle__1m_oY","preview":"styles_preview__1-9ai"};